<list-view *ngIf="enveloppes" [liste]="enveloppes"></list-view>
<floating-button [listeActions]="listeActions"></floating-button>
